module.exports = __webpack_public_path__ + "static/image/service/m/gift@3x.jpg?cac09f2c";